// STAG TEST
export const environment = {
    appVersion: '2.1.2 DEV',
    production: false,
    ConfigEndpoints: {
        "captive_portal_url": "https://mycaptive.guglielmo.dev/api/v2/",
        "configuration_url": "https://mycaptive.guglielmo.dev/aaa_configuration/",
        "mycaptive": "https://mycaptive.guglielmo.dev",
        "login": "https://login.caligoo.com/",
        "analytics_url": "https://aaa-analytics.caligoo.com/dashboard/",
        "captive_config": "/captive-config/",
        "preview_captive_portal": "https://mycaptive.guglielmo.dev",
        // "configuration_mac": "https://mycaptive.guglielmo.dev/aaa_utils/mac_address",
        "configuration_mac": "https://mycaptive.guglielmo.dev/mac_address",
        "captive_vendors": "https://mycaptive.guglielmo.dev/aaa_configuration/vendors",
        "monitoring_sessions": "https://mycaptive.guglielmo.dev/operations/",
        "passpoint_url": "http://aaa-testing.caligoo.com:6200/",
        "gdpr_url":"https://gdpr.guglielmo.dev/v2/"
    },
    tinymce: {
        apiKey: '1qmbleq7uq3g912qiwol60w81vrdcvqq2gactu1qi5ken7qp',
    },
    keycloak: {
        enabled: true,
        url: 'https://keycloak.guglielmo.dev/auth',
        realm: 'MyCaptive',
        clientId: 'dashboard-frontend',
        onLoad: 'login-required',
        adapterScriptUrl: '/assets/keycloak/keycloak-loader.js',
        adapterLoadTimeout: 10000,
        pkceMethod: 'S256',
        checkLoginIframe: false,
        minValiditySeconds: 30,
        requiredRoles: ['Admin', 'Helpdesk_L1', 'Technical_Support_L2'],
        legacyUserStorage: true,
        claims: {
            consumerName: ['consumer_name', 'consumer', 'dashboard_account', 'tenant'],
            credentialUsername: ['credential_username', 'preferred_username', 'email']
        }
    }
};

// PROD TEST
// export const environment = {
//     appVersion: '2.0.4',
//     production: true,
//     ConfigEndpoints: {
//         "captive_portal_url": "https://captive.guglielmo.biz/v2/api/",
//         "configuration_url": "https://captive.guglielmo.biz/v2/aaa_configuration/",
//         "mycaptive": "http://localhost:8282",
//         "login": "https://login.caligoo.com/",
//         "analytics_url": "https://mycaptive.guglielmo.biz:65443/dashboard/",
//         "captive_config": "https://captive.guglielmo.biz/v2/conf/",
//         "preview_captive_portal": "https://captive.guglielmo.biz/v2/preview/",
//         "configuration_mac": "https://captive.guglielmo.biz/v2/aaa_utils/mac_address",
//         "captive_vendors": "https://captive.guglielmo.biz/v2/aaa_configuration/vendors",
//         "monitoring_sessions": "https://captive.guglielmo.biz/v2/operations/",
//         "passpoint_url": "https://profile.guglielmo.biz/",
//         "gdpr_url":"https://gdpr.guglielmo.biz/v2/"

//     },
//     tinymce: {
//         apiKey: '1qmbleq7uq3g912qiwol60w81vrdcvqq2gactu1qi5ken7qp',
//     },
//     keycloak: {
//         enabled: true,
//         url: 'https://auth2.guglielmo.biz/auth',
//         realm: 'MyCaptive',
//         clientId: 'dashboard-frontend',
//         onLoad: 'login-required',
//         adapterScriptUrl: '/assets/keycloak/keycloak-loader.js',
//         adapterLoadTimeout: 10000,
//         pkceMethod: 'S256',
//         checkLoginIframe: false,
//         silentCheckSsoRedirectUri: '/assets/silent-check-sso.html',
//         minValiditySeconds: 30,
//         requiredRoles: ['Admin', 'Helpdesk_L1', 'Technical_Support_L2'],
//         legacyUserStorage: true,
//         claims: {
//             consumerName: ['consumer_name', 'consumer', 'dashboard_account', 'tenant'],
//             credentialUsername: ['credential_username', 'preferred_username', 'email']
//         }
//     }
// };
